// Adressen von Dateien, die nicht durch den Bündler laufen.
//
// `public/` wird unverändert kopiert — Vite fasst diese Dateien nicht an und
// kennt ihre Adressen deshalb auch nicht. Ein absoluter Pfad wie
// `/logo-white.svg` zeigt damit an der Basis vorbei: Die Oberfläche liegt
// unter /watcher/, das Logo läge an der Wurzel.
//
// `BASE_URL` ist das, was in vite.config.ts als `base` steht — hier steht der
// Pfad also nicht ein zweites Mal.

const BASE = import.meta.env.BASE_URL

export const LOGO = `${BASE}logo-white.svg`
